import React from "react";
import { RootState } from "../../../store/store";
import { confirmDialog } from "../../Dialog/actions";
import { connect } from 'react-redux';
import { IUserProfile } from "../../Auth/types";
import { anyDepNeedUpdate } from "../services";
import Helper from "../../../core/libraries/Helper";


interface IProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
}

class DepartmentChangesAlert extends React.Component<IProps, any> {

    async componentDidUpdate(prevProps: Readonly<IProps>): Promise<void> {
        if (this.props.userProfile !== prevProps.userProfile) {
            if (!!this.props.userProfile && this.props.userProfile.permissions?.isSuperAdmin) {
                !!await anyDepNeedUpdate() && this.props.confirmDialog("Department Changes", "There have been some updates to the department. Please click 'OK' to navigate to the Departments page and verify if they are ready for migration.", false, () => {
                    Helper.openNewTab(`${process.env.REACT_APP_DEPARTMENTS}`);
                })
            }
        }
    }

    constructor(props: any) {
        super(props);
        this.state = {
            isShow: true,
            orderItems: [],
        };
    }

    render() {
        return <></>
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default connect(mapStateToProps, { confirmDialog })(DepartmentChangesAlert);